import { BaseURL } from "./BaseURL";
const authToken = localStorage.getItem("p@token");


export async function checkProductAdd(productId) {
    try {
        const response = await fetch(`${BaseURL}/api/addSystem/addChecker/check-product-add/${productId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": authToken
            }
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        const data = await response.json();
        return data ? true : false;
    } catch (error) {
        console.error("Failed to fetch product ad:", error.message);
        return { error: error.message };
    }
}



export async function checkProfileAdd() {
    try {
        const response = await fetch(`${BaseURL}/api/addSystem/addChecker/check-profile-add`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": authToken
            }
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        const data = await response.json();
        return data ? true : false; // Returns the active profile ad or null
    } catch (error) {
        console.error("Failed to fetch profile ad:", error.message);
        return { error: error.message }; // Error handling
    }
}


export const CreateLog = async (action, metaData, role)=>{
    try{
        
        const response = await fetch(`${BaseURL}/api/userLogs/create-log`, {
            method:"POST",
            body: JSON.stringify({
                action,
                metaData,
                role
            }),
            headers: {
                'Content-Type': 'application/json',
                "auth-token": authToken
            }
        });
    }catch(e){
        console.log(e)
    }
}
